<style>

.tableDesign .el-input__inner {
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs
        active-name="1"
        tab-position="left"
        style="background-color: #ffffff;height: 800px"
        @tab-click="handleTabClick"
      >
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel
            ref="CommonExcelRef2"
            :import-p="'config:userLabel:import'"
            :export-p="'config:userLabel:export'"
            :import-method="importCfg"
            :export-method="exportCfg"
          />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button
                v-prevent-re-click
                type="primary"
                size="mini"
                style="margin:10px 10px"
                @click="handleSaveConfig()"
              >保存
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="70%">
        <el-table
          :key="tableKey"
          size="mini"
          :data="diaLogList"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          height="500"
        >
          <template v-if="type==1">
            <el-table-column prop="stage" label="阶段">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column prop="stepnum" label="进度">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stageNum" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column prop="奖励" label="奖励">
              <template slot-scope="scope">
                <Reward :value="scope.row.rewards" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==2">
            <el-table-column prop="stage" label="Id">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.id" placeholder="Id" />
              </template>
            </el-table-column>
            <el-table-column prop="stepnum" label="权重">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.v" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.num" placeholder="数量" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="奖励类型">
              <template slot-scope="scope">
                <el-select v-model.number="scope.row.type" placeholder="请选择">
                  <el-option
                    v-for="item in wheelType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==3">
            <el-table-column prop="maxNum" label="购买次数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.maxNum" placeholder="Id" />
              </template>
            </el-table-column>
            <el-table-column prop="expireTime" label="过期时间(秒)">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.expireTime" :disabled="scope.$index < 3" placeholder="过期时间(秒)" />
              </template>
            </el-table-column>
            <el-table-column label="商品配置" align="center">
              <Price />
            </el-table-column>
            <el-table-column label="是否随机礼包" align="center" width="120">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isRandom" @change="(val) => handleRandomChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="奖励" align="center">
              <template slot-scope="{row}">
                <Reward v-if="!row.isRandom" v-model="row.prize" />
                <el-button v-else type="text" @click.stop="openRandomGoodsDialog(row)">配置随机奖励</el-button>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{row,$index}">
              <el-button
                style="margin-left: .5rem;display:block;"
                size="mini"
                type="danger"
                @click="deleteRewardDialogList($index)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px">
          <el-button size="small" :disabled="addMaxNum()" type="primary" @click="addRewardDialogList">新增</el-button>
        </span>
        <span slot="footer" class="dialog-footer"><el-button
          v-prevent-re-click
          type="primary"
          size="mini"
          style="margin:10px 10px"
          @click="handleSaveConfig()"
        >保存
        </el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>

      </el-dialog>
      <el-drawer
        append-to-body
        :show-close="false"
        :before-close="handleRandomGoodsClose"
        title="配置随机奖励"
        :visible.sync="randomGoodsDialog"
        size="40%"
      >
        <template #title>
          <span>配置随机奖励</span>
        </template>
        <el-form :inline="true">
          <el-row v-for="(r,i) in currentRandomGoods" :key="i">
            <el-form-item label="序号" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input-number v-model="r.id" :controls="false" :min="1" size="small" style="width: 80px;" disabled />
            </el-form-item>
            <el-form-item label="商品" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-cascader
                v-model.number="r.propsId"
                size="small"
                :options="propsOption"
                :props="{ expandTrigger: 'hover',emitPath:false }"
                :show-all-levels="false"
                style="width: 150px;"
              />
            </el-form-item>
            <el-form-item label="数量" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input v-model.number="r.num" size="small" style="width: 90px;" placeholder="数量" />
            </el-form-item>
            <el-form-item label="权重" style="margin-top: 10px;margin-bottom: 12px!important;">
              <el-input v-model.number="r.weight" size="small" style="width: 90px;" placeholder="权重" />
            </el-form-item>
          </el-row>
        </el-form>
        <div style="margin-top: 20px; text-align: right; padding-right: 20px;">
          <el-button
            v-prevent-re-click
            type="primary"
            size="mini"
            style="margin:10px 10px"
            @click="handleSaveConfig()"
          >保存</el-button>
          <el-button size="small" @click="randomGoodsDialog = false">关 闭</el-button>
        </div>
      </el-drawer>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { handleImportPrize } from '@/utils'
import Price from '@/components/Price/index.vue'
import { getRewardType } from '@/api/config/slot'
import { getCacheConfig } from '@/utils'

export default {
  name: 'BuildPartners',
  components: { Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      limitType: [2],
      loading: false,
      dialog: false,
      diaLogList: [],
      currentEditRowIndex: undefined,
      list: [],
      curClass: 'build_partners',
      type: 1,
      typeArr: { 1: '建造配置', 2: '转盘配置', 3: '礼包配置' },
      shopSku: [],
      wheelType: [
        {
          'value': 1,
          'label': '正常'
        },
        {
          'value': 2,
          'label': '免费转一次'
        },
        {
          'value': 3,
          'label': '给合作伙伴发奖励'
        }
      ],
      randomGoodsDialog: false,
      currentRandomGoods: [],
      currentEditRow: null,
      propsOption: [
        {
          value: 100000,
          label: '等级金币',
          children: [],
          props: [14, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5013, 5014, 5015, 5016, 5017, 5018, 5019, 5020]
        },
        {
          value: 100001,
          label: '常规道具',
          children: [],
          props: [15, 16, 22, 37, 42, 65, 74, 82, 83, 89, 90, 109, 110, 111]
        },
        { value: 100002, label: '卡片道具', children: [], props: [1, 2, 3, 13, 79, 18, 107, 108] },
        {
          value: 100003,
          label: '皮肤道具',
          children: [],
          props: [19, 23, 71, 86, 62, 67, 68, 76, 77, 78, 101, 102, 103, 104, 105, 106]
        },
        {
          value: 100004,
          label: '活动道具',
          children: [],
          props: [25, 28, 31, 32, 36, 41, 53, 55, 72, 73, 75, 80, 81, 85, 88]
        }
      ]
    }
  },
  created() {
    this.init()
    this.initPropsOption()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$nextTick(() => {
        if (this.currentEditRowIndex !== undefined && this.currentEditRowIndex !== -1) {
          this.$set(this.list[this.type][this.currentEditRowIndex], 'config', JSON.parse(JSON.stringify(this.diaLogList)))
        }
        done()
      })
    },
    openDialog(config) {
      this.currentEditRowIndex = this.list[this.type].findIndex(item => item.config === config)
      this.tableKey++
      this.diaLogList = config.map(item => ({
        ...item,
        isRandom: item.isRandom || false,
        randomGoods: item.randomGoods || [],
        prize: item.prize || []
      }))
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = handleImportPrize(excelData[i].sheetData)
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, handleImportPrize(excelData[i].sheetData))
        }
      }
    },
    handleSaveConfig(type) {
      if (this.dialog && this.currentEditRowIndex !== undefined && this.currentEditRowIndex !== -1) {
        this.$set(this.list[this.type][this.currentEditRowIndex], 'config', JSON.parse(JSON.stringify(this.diaLogList)))
      }

      const saveList = JSON.parse(JSON.stringify(this.list))
      for (const type in saveList) {
        if (type === 3) {
          saveList[type].forEach(config => {
            if (config.config && Array.isArray(config.config)) {
              config.config = config.config.map(item => {
                const saved = { ...item }
                if (!saved.isRandom) {
                  delete saved.randomGoods
                } else {
                  delete saved.prize
                }
                return saved
              })
            }
          })
        }
      }

      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      let field = {}
      switch (this.type) {
        case 1:
          fileName = '进度配置'
          field = {
            stage: '阶段',
            stepnum: '步骤进度',
            rewards: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          break

        case 2:
          fileName = '奖励配置'
          field = {
            stage: '阶段',
            stepNum: '步骤进度',
            name: '多语言名称',
            gMax: '可购买',
            mtype: '类型',
            sku: '库存',
            bet: '倍数',
            price: '价格',
            prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          break

        case 3:
          fileName = '礼包配置'
          field = {
            maxNum: '购买次数',
            mtype: '类型',
            sku: '库存',
            bet: '倍数',
            price: '价格',
            prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          break
      }
      // fileName = this.typeArr[type]
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], field)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }

      downloadExcelMultiSheet(this.$route.meta.title + '-' + fileName, name, hearer, excelData)
    },
    addRewardDialogList(index) {
      const len = this.diaLogList.length
      switch (this.type) {
        case 1:
          {
            const stageArr = [
              { stage: 1, stageNum: 1, rewards: [] },
              { stage: 2, stageNum: 1, rewards: [] },
              { stage: 3, stageNum: 1, rewards: [] },
              { stage: 4, stageNum: 1, rewards: [] },
              { stage: 5, stageNum: 1, rewards: [] }
            ]
            this.diaLogList.push(...stageArr)
          }
          break
        case 2:
          this.diaLogList.push({ id: len + 1, num: 1, type: 1, v: 0 })
          break
        case 3:
          this.diaLogList.push({
            maxNum: 0,
            expireTime: 0,
            effectiveTime: 0,
            prize: [],
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            maxNum: 0,
            expireTime: 0,
            effectiveTime: 0,
            prize: [],
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            maxNum: 0,
            expireTime: 0,
            effectiveTime: 0,
            prize: [],
            isRandom: false,
            randomGoods: []
          })
          this.diaLogList.push({
            maxNum: 0,
            expireTime: 0,
            effectiveTime: 0,
            prize: [],
            isRandom: true,
            randomGoods: []
          })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    addMaxNum() {
      switch (this.type) {
        case 1:
          if (this.diaLogList.length > 0) {
            return true
          }
          break

        case 3:
          if (this.diaLogList.length >= 3) {
            return true
          }
          break
      }
      return false
    },
    initPropsOption() {
      getCacheConfig(getRewardType, 'getRewardType1', { data: 1 }).then(res => {
        const rewardTypeMap = res.data
        for (const i in rewardTypeMap) {
          const propsId = parseInt(i)
          for (let j = 0; j < this.propsOption.length; j++) {
            if (this.propsOption[j].props.indexOf(propsId) >= 0) {
              this.propsOption[j].children.push({ label: rewardTypeMap[i], value: propsId })
              break
            }
          }
        }
      })
    },
    handleRandomGoodsClose(done) {
      done()
    },
    handleRandomChange(row, val) {
      if (val) {
        if (!row.randomGoods || row.randomGoods.length === 0) {
          row.randomGoods = []
          for (let i = 1; i <= 8; i++) {
            row.randomGoods.push({ id: i, propsId: 74, num: 1, weight: 100 })
          }
        }
        row.prize = []
      } else {
        row.randomGoods = []
        row.prize = []
      }
    },
    openRandomGoodsDialog(row) {
      this.currentEditRow = row
      this.currentRandomGoods = row.randomGoods || []
      this.randomGoodsDialog = true
    }
  }
}
</script>

